import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretDown } from '@fortawesome/sharp-solid-svg-icons/faCaretDown';
import { faCaretUp } from '@fortawesome/sharp-solid-svg-icons/faCaretUp';

import styles from './number-input-right-section.module.css';

import type { NumberInputHandlers } from '@mantine/core';
import type { RefObject } from 'react';

type NumberInputRightSectionProps = {
  label?: string;
  handlersRef: RefObject<NumberInputHandlers | undefined>;
  inputRef: RefObject<HTMLInputElement | null>;
  disabled?: boolean;
};

export const NumberInputRightSection = ({ label, handlersRef, inputRef, disabled }: NumberInputRightSectionProps) => {
  const increment = (e: React.PointerEvent) => {
    if (disabled) {
      return;
    }
    e.preventDefault();
    inputRef.current?.focus();
    handlersRef.current?.increment();
  };

  const decrement = (e: React.PointerEvent) => {
    if (disabled) {
      return;
    }
    e.preventDefault();
    inputRef.current?.focus();
    handlersRef.current?.decrement();
  };

  return (
    <div className={styles.rightSection}>
      {label && <span className={styles.unitLabel}>{label}</span>}
      <div className={styles.controls}>
        <button aria-hidden className={styles.controlButton} disabled={disabled} onPointerDown={increment} tabIndex={-1} type='button'>
          <FontAwesomeIcon className={styles.caret} icon={faCaretUp} />
        </button>
        <button aria-hidden className={styles.controlButton} disabled={disabled} onPointerDown={decrement} tabIndex={-1} type='button'>
          <FontAwesomeIcon className={styles.caret} icon={faCaretDown} />
        </button>
      </div>
    </div>
  );
};
